<template>
  <Popover
    ref="popover"
    trigger="hover"
    placement="top"
    :offset="{ y: 5 }"
    @show="loadUsers()"
  >
    <template #trigger>
      <slot />
    </template>
    <template #content>
      <div class="user-list-popover">
        <template v-if="loading">
          <FAIcon
            icon="circle-notch"
            spin
            size="2x"
            :title="$t('general.loading')"
          />
        </template>
        <template v-else-if="failed">
          <span>{{ $t('general.generic_error') }}</span>
          <button
            class="btn button-default participants-retry"
            type="button"
            @click.stop="loadUsers(true)"
          >
            {{ $t('general.retry') }}
          </button>
        </template>
        <template v-else-if="usersCapped.length > 0">
          <UserListRow
            v-for="user in usersCapped"
            :key="user.id"
            :user="user"
          />
        </template>
        <template v-else>
          {{ $t('search.no_results') }}
        </template>
        <button
          v-if="moreShown"
          class="button-unstyled -link participants-more"
          type="button"
          @click.stop="openAll"
        >
          {{ users.length > 16 ? $t('status.participants_more', { count: users.length - 16 }) : $t('status.participants_more_available') }}
        </button>
      </div>
    </template>
  </Popover>
</template>

<script src="./user_list_popover.js"></script>

<style lang="scss">
.user-list-popover {
  padding: 0.5em;
  max-height: 40vh;
  overflow-y: auto;

  --emoji-size: calc(var(--emojiSize, 32px) / 2);

  // stays in view at the end of a scrolling list
  .participants-more {
    position: sticky;
    bottom: -0.5em;
    display: block;
    width: 100%;
    padding: 0.5em 0.25em;
    text-align: center;
    background-color: var(--background);
  }
}
</style>
